export default {
  // Page titles and navigation
  pageTitle: 'Node Management',
  businessTypeSelector: 'Select Business Type:',
  businessNodeEditor: 'Business Node Editor',

  // Business types
  businessTypes: {
    sea: 'Sea Freight Orders',
    air: 'Air Freight Orders',
    land: 'Land Freight Orders',
    rail: 'Rail Freight Orders'
  },

  // Node related
  node: {
    name: 'Node Name',
    description: 'Node Description',
    icon: 'Node Icon',
    enabled: 'Enable Status',
    tasks: 'Tasks',
    taskCount: '{count} tasks',
    addNode: 'Add Node',
    editNode: 'Edit Business Node',
    insertNode: 'Insert Business Node',
    createNode: 'Create Business Node',
    deleteNode: 'Delete Node',
    deleteConfirm: 'Confirm Delete Node',
    deleteMessage: 'This action cannot be undone. Are you sure you want to delete this business node?',
    confirmDelete: 'Confirm Delete',
    startNode: 'Start',
    startNodeDescription: 'Workflow start node'
  },

  // Form related
  form: {
    nodeNamePlaceholder: 'Enter node name, e.g.: Quote Confirmation',
    nodeNameRequired: 'Please enter node name',
    nodeDescriptionPlaceholder: 'Enter node description (optional)',
    nodeIconLabel: 'Node Icon',
    uploadIcon: 'Upload Icon',
    iconFormat: 'Supports JPG, PNG, GIF formats, file size up to 2MB',
    enabledLabel: 'Enable Status'
  },

  // Task management
  tasks: {
    title: 'Task Configuration',
    addTask: 'Add Task',
    deleteTask: 'Delete Task',
    taskName: 'Task Name',
    taskType: 'Task Type',
    contactPersonType: 'Contact Person Type',
    exclusiveContactPerson: 'Exclusive Contact Person',
    skippable: 'Skippable',
    relatedPage: 'Related Page (Optional)',
    parentTask: 'Parent Task (Optional)',
    deadline: 'Deadline (Optional)',

    // Task types
    types: {
      external: 'External Task',
      internal: 'Internal Task'
    },

    // Contact person types
    contactPersonTypes: {
      exclusive: 'Exclusive Contact Person',
      businessOwner: 'Business Owner'
    },

    // Exclusive contact options
    exclusiveContactOptions: {
      sales: 'Exclusive Sales',
      customer_service: 'Exclusive Customer Service',
      operation: 'Exclusive Operation',
      documentation: 'Exclusive Documentation',
      business: 'Exclusive Business',
      finance: 'Exclusive Finance'
    },

    // Deadline configuration
    deadlineConfig: {
      baseEvent: 'Select Base Event',
      direction: 'Select Direction',
      value: 'Value',
      unit: 'Unit'
    },

    // Form validation
    validation: {
      taskNamePlaceholder: 'Please enter task name',
      selectContactPersonType: 'Please select contact person type',
      selectExclusiveContactPerson: 'Please select exclusive contact person',
      selectRelatedPage: 'Please select related page',
      selectParentTask: 'Please select parent task',
      selectBaseEvent: 'Select base event',
      selectDirection: 'Select direction',
      enterValue: 'Value',
      selectUnit: 'Select unit',
      exclusiveContactPersonRequired: 'Please select exclusive contact person'
    },

    // Task status
    noTasks: 'No tasks yet, click "Add Task" to start configuration',
    taskIndex: 'Task {index}',
    autoGenerated: 'Auto-generated'
  },

  // Toolbar operations
  toolbar: {
    addNode: 'Add Node',
    resetLayout: 'Reset Layout',
    saveSettings: 'Save Settings'
  },

  // Save confirmation dialog
  saveDialog: {
    title: 'Confirm Save',
    message: 'After saving, business nodes will take effect for all new businesses. Confirm save?',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },

  // Button text
  buttons: {
    save: 'Save',
    update: 'Update',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit'
  },

  // Success/Error messages
  messages: {
    configLoadSuccess: '{businessType} configuration loaded successfully',
    configLoadFailed: 'Failed to load workflow configuration',
    workflowNotInitialized: 'No workflow exists for this business type yet. Please contact an administrator.',
    configSaveSuccess: 'Configuration saved successfully',
    configSaveFailed: 'Failed to save configuration',
    nodeUpdateSuccess: 'Node updated successfully',
    nodeAddSuccess: 'Node added successfully',
    nodeInsertSuccess: 'Node inserted successfully',
    iconUploadSuccess: 'Icon uploaded successfully',
    iconUploadFailed: 'Icon upload failed',
    iconRemoved: 'Icon removed',
    imageLoadError: 'Failed to load node icon',
    formValidationFailed: 'Form validation failed',

    // File upload related
    fileInvalid: 'Invalid file object',
    imageTypeError: 'Only image files are allowed!',
    fileSizeError: 'Image size cannot exceed 2MB!',
    uploadError: 'Upload failed, file ID not received',

    // Page loading related
    pageConfigLoadFailed: 'Failed to get page configuration',

    // Auto-generated task related
    cannotModifyAutoGeneratedTaskParent: 'The parent task of auto-generated tasks cannot be modified'
  },

  // Other text
  others: {
    currentBusinessType: 'Current Business Type',
    workflowStartNode: 'Workflow Start Node',
    cannotEditStartNode: 'Start node cannot be edited',
    cannotDeleteStartNode: 'Start node cannot be deleted',
    savingConfig: 'Saving configuration data',
    loadingPageConfig: 'Loading page configuration'
  }
}
